<template>
  <div>
    <label for="image" class="image-title">Image</label>
    <br />
    <div
      id="image"
      v-cloak
      @drop.prevent="onFileChange"
      @dragover.prevent
      :class="[
        {
          'modal-style': !image,
          'modal-style-image': image,
          'text-center': image,
        },
      ]"
    >
      <div class="upload" @click="trigger()">
        <svg v-if="!image" class="cloud-upload-icon svg-color">
          <use xlink:href="/svg-icons/sprites/icons.svg#cloud-upload-icon" />
        </svg>
        <img
          v-else
          id="newGroupImage"
          class="img-responsive"
          style="max-height: 180px"
          :style="exif_rotate"
          :src="groupPostFeaturedImage.image"
          alt="Photo"
        />
        <div v-if="!image">
          <h6>Drag and drop here</h6>
        </div>
        <input
          type="file"
          ref="fileInput"
          class="input-file"
          style="display: none"
          @change="onFileChange"
          accept="image/*"
          data-cy="inputGroupImage"
        />
        <span v-if="!image" class="d-block">Maximum size: 3.5MB</span>

        <div v-if="!valid_img" class="error-box mt-3 mb-2 mr-1 ml-1">
          <span
            >Sorry, this file is invalid, please upload an PNG/JPEG/JPG image
            file</span
          >
        </div>

        <div v-if="heavy_img" class="error-box mt-3 mr-1 ml-1">
          <span
            >Sorry, your image is too large, please select another image</span
          >
        </div>
      </div>
      <SButton
        text="Clear"
        class="button-update"
        @button="clearFile"
        v-if="image"
      />
    </div>
  </div>
</template>

<script>
import ImageModule from "@/modules/Image";
import { mapActions, mapGetters } from "vuex";
import SButton from "@/components/atoms/SButton";
import GroupHelperVue from "@/mixins/GroupHelper.vue";

export default {
  name: "NewGroupImage",
  mixins: [GroupHelperVue],
  components: {
    SButton,
  },
  data() {
    return {
      image: null,
      image_file: "",
      progress: 0,
      upload_complete: false,
      valid_img: true,
      heavy_img: false,
      exif_rotate: "",
      image_size_limit: 3670016,
    };
  },
  computed: {
    ...mapGetters({
      groupPostFeaturedImage: "getNewGroupImage",
    }),
  },
  watch: {
    image: function () {
      this.setNewGroupImage({ image: this.image });
      this.setNewGroupImageFile({ imageFile: this.image_file });
      this.$emit("file", this.image_file);
    },
    newitem_image_orientation: function (val) {
      this.updateImageOrientation(val);
    },
  },
  methods: {
    ...mapActions([
      "setNewGroupImage",
      "setNewGroupImageFile",
      "setNewGroupImageOrientation",
    ]),
    trigger() {
      this.$refs.fileInput.click();
    },
    clearFile() {
      this.resetGroupImage();
      this.image = null;
      this.image_file = "";
      this.$refs.fileInput.value = null;
    },
    onFileChange(e) {
      let self = this;

      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return false;
      } else if (
        files[0]["type"] !== "image/jpeg" &&
        files[0]["type"] !== "image/png"
      ) {
        self.valid_img = false;
        self.image = null;
        return false;
      }
      if (files[0].size > this.image_size_limit) {
        self.heavy_img = true;
        self.image = null;
        return false;
      }

      self.valid_img = true;
      self.heavy_img = false;
      this.loadImage(files[0]);
    },
    loadImage(file) {
      ImageModule.getOrientation(file, (orientation) => {
        this.setNewGroupImageOrientation({ imageOrientation: orientation });
      });
      const reader = new FileReader();
      const vm = this;
      vm.image_file = file;

      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    updateImageOrientation(val) {
      let self = this;
      self.exif_rotate = "";
      switch (val) {
        case 1:
        case -1:
          self.exif_rotate += "";
          break;
        case 2:
          self.exif_rotate += "transform: scale(-1, 1)";
          break;
        case 3:
          self.exif_rotate += "transform: rotate(180deg)";
          break;
        case 4:
          self.exif_rotate +=
            "transform: rotate(180deg);transform: scale(-1, 1)";
          break;
        case 5:
          self.exif_rotate +=
            "transform: rotate(90deg);transform: scale(-1, 1)";
          break;
        case 6:
          self.exif_rotate += "transform: rotate(90deg)";
          break;
        case 7:
          self.exif_rotate +=
            "transform: rotate(270deg);transform: scale(-1, 1)";
          break;
        case 8:
          self.exif_rotate += "transform: rotate(270deg)";
          break;
      }
    },
    retrieveImageFromClipboardAsBlob(pasteEvent, callback) {
      if (pasteEvent.clipboardData === false) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }

      const items = pasteEvent.clipboardData.items;

      if (items == undefined) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }
      for (const element of items) {
        if (element.type.indexOf("image") === -1) continue;
        const blob = element.getAsFile();
        if (typeof callback === "function") {
          callback(blob);
        }
      }
    },
  },
  created() {
    window.addEventListener(
      "paste",
      (event) => {
        if ($("#create-group").is(":visible")) {
          this.retrieveImageFromClipboardAsBlob(event, (imageBlob) => {
            this.loadImage(imageBlob);
          });
        }
      },
      false
    );
  },
  mounted() {
    if (this.groupPostFeaturedImage.image) {
      this.image = this.groupPostFeaturedImage.image;
    }
  },
};
</script>

<style lang="scss" scoped>
label.image-title {
  margin: 0 !important;
  float: left;
  display: block;
}
.upload {
  display: inline-block;
  margin: auto;
  text-align: center;
  cursor: default;
}
.cloud-upload-icon {
  width: 80px;
  height: 80px;
}
.modal-style,
.modal-style-image {
  border: 2px dashed;
  height: 238px;
  max-height: 238px;
  margin-bottom: 35px;
}
.modal-style-image {
  display: block;
}
.modal-style {
  display: flex;
}
.modal-style-image .upload {
  display: inline-block;
  margin: auto;
  text-align: center;
  cursor: default;
}
.button-update {
  color: white;
  background-color: $primary;
  display: block;
  margin: 1.2em auto;
}
.svg-color {
  fill: #c2c5d9;
}
.d-block {
  font-size: 10px;
  font-weight: bold;
  line-height: 12px;
}
</style>
